// extracted by css-extract-rspack-plugin
export default {"standardContent":"standardContent-UEtiiB","tosContent":"tosContent-B66MRl"};